import {toNumber} from "@/lib/utils";

const getEnv = (key: string, def?: string) => {
  if (typeof process !== 'undefined') {
    return _env(process.env['REACT_' + key] || process.env[key], def);
  } else if (typeof import.meta !== 'undefined') {
    return _env(import.meta.env['VITE_' + key] || import.meta.env[key], def);
  }
};

const _env = (value: string | undefined, defaultValue: string = ''): string => {
  return value === undefined ? defaultValue : value.trim();
};

const getString = (key: string, def?: string): string => {
  const value = getEnv(key, def);
  return value === undefined ? (def || '') : value.trim();
}

export const config = {
  env: getString('VITE_ENV'),
  isDev: import.meta.env['DEV'],
  appUrl: getString('VITE_APP_URL'),
  apiUrl: getString('VITE_API_URL'),
  google: {
    captchaSiteKey: getString('VITE_GOOGLE_CAPTCHA_SITE_KEY'),
    auth: {
      clientId: getString('VITE_GOOGLE_AUTH_CLIENT_ID'),
    }
  },
  microsoft: {
    msal: {
      clientId: getString('VITE_MICROSOFT_MSAL_CLIENT_ID'),
      tenantId: getString('VITE_MICROSOFT_MSAL_TENANT_ID')
    }
  },
  amazon_sp: {
    application_id: getString('VITE_AMAZON_SP_APPLICATION_ID')
  },
  ls: {
    url: getString('VITE_LS_URL'),
    adapterSet: getString('VITE_LS_ADAPTER_SET'),
    dataAdapter: getString('VITE_LS_DATA_ADAPTER')
  },
  fees: {
    sellerFeePercent: 0,
    investorFeePercent: 0,
    investorProfitFeePercent: 0,
    calcInvestorFee(bidAmt?: number, profit?: number) {
      if (bidAmt === undefined) {
        return undefined;
      }
      let fee = toNumber(bidAmt) * this.investorFeePercent;
      if (profit !== undefined) {
        fee += toNumber(profit) * this.investorProfitFeePercent;
      }
      return fee;
    },
    calcSellerFee(askPrice?: number) {
      if (askPrice === undefined) {
        return undefined;
      }
      return toNumber(askPrice) * this.sellerFeePercent;
    }
  },
  navigateOnLogin: "/dashboard",
  demoSellerId: toNumber(getString('VITE_DEMO_SERVER_ID')),
}